var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-32p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3399_6721",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3399_6721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "error",
    d: "M16.0009 22.6665C16.3345 22.6665 16.6143 22.5537 16.8402 22.328C17.0661 22.1023 17.1791 21.8227 17.1791 21.4891C17.1791 21.1555 17.0662 20.8758 16.8406 20.6498C16.6149 20.4239 16.3353 20.311 16.0017 20.311C15.6681 20.311 15.3883 20.4238 15.1624 20.6495C14.9365 20.8751 14.8235 21.1547 14.8235 21.4883C14.8235 21.8219 14.9364 22.1017 15.162 22.3276C15.3877 22.5535 15.6673 22.6665 16.0009 22.6665ZM14.9569 17.4887H17.1791V9.19984H14.9569V17.4887ZM16.0072 29.3332C14.1667 29.3332 12.4371 28.9832 10.8183 28.2832C9.19958 27.5832 7.78649 26.6295 6.57907 25.4221C5.37167 24.2146 4.41797 22.801 3.71797 21.1812C3.01797 19.5613 2.66797 17.8305 2.66797 15.9887C2.66797 14.147 3.01797 12.4161 3.71797 10.7963C4.41797 9.17644 5.37167 7.7665 6.57907 6.5665C7.78649 5.3665 9.20012 4.4165 10.82 3.7165C12.4398 3.0165 14.1706 2.6665 16.0124 2.6665C17.8542 2.6665 19.585 3.0165 21.2048 3.7165C22.8247 4.4165 24.2346 5.3665 25.4346 6.5665C26.6346 7.7665 27.5846 9.17762 28.2846 10.7998C28.9846 12.4221 29.3346 14.1534 29.3346 15.9939C29.3346 17.8344 28.9846 19.564 28.2846 21.1828C27.5846 22.8016 26.6346 24.2133 25.4346 25.418C24.2346 26.6226 22.8235 27.5763 21.2013 28.2791C19.5791 28.9818 17.8477 29.3332 16.0072 29.3332ZM16.0124 27.111C19.1013 27.111 21.7235 26.0295 23.8791 23.8665C26.0347 21.7036 27.1124 19.0776 27.1124 15.9887C27.1124 12.8998 26.036 10.2776 23.8833 8.12204C21.7305 5.96648 19.1031 4.8887 16.0013 4.8887C12.9198 4.8887 10.2976 5.96509 8.13464 8.11787C5.97166 10.2707 4.89017 12.898 4.89017 15.9998C4.89017 19.0813 5.97166 21.7036 8.13464 23.8665C10.2976 26.0295 12.9235 27.111 16.0124 27.111Z",
    fill: "#D79304"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ce4ed8e10bb5d1e3ca0371cddd80810b.svg";
export { ForwardRef as ReactComponent };